<template>
  <div>
    <template
      v-if="
        !page.page_content['slot-classes'] ||
        page.page_content['slot-classes'].length < 1
      "
    >
      500 Internal Server Error
    </template>

    <template v-else>
      <RecursiveLevelSlot
        :node="ExtraLevelTreeBySlot[parent['slot-name']]"
        v-bind:key="indexParent"
        v-for="(parent, indexParent) in page.page_content['slot-classes']"
      >
        <RecursiveLevelSection
          v-bind:key="indexContent"
          v-for="(page_section, indexContent) in parent.page_sections
            ? parent.page_sections
            : []"
          :node="LevelTreeBySection[page_section.page_section_id]"
          :languageCodeList="languageCodeList"
          :isClientPage="isClientPage"
        />
      </RecursiveLevelSlot>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-console */

import RecursiveLevelSlot from '@/components/page-loading-components/RecursiveLevelSlot';
import RecursiveLevelSection from '@/components/page-loading-components/RecursiveLevelSection';

export default {
  name: 'ContentLoader',
  props: ['language', 'languageCodeList', 'page', 'entityId', 'isClientPage'],
  components: {
    RecursiveLevelSlot,
    RecursiveLevelSection,
  },
  data() {
    return {
      class_from_page: '',
      extra_level: null,
    };
  },
  async created() {
    await this.initPage();
  },
  computed: {
    dataBackgroundImages() {
      const BackgroundImageBySlot = {};

      this.page.page_content['slot-classes']
        .filter((s) => s.page_sections)
        .forEach((parent) => {
          const page_imageSection = parent.page_sections.find(
            (page_section) =>
              page_section.section.section_type.section_type_name === 'image' &&
              page_section.section_display.behaviors &&
              page_section.section_display.behaviors['is-background-image'] ===
                true
          );

          if (page_imageSection) {
            BackgroundImageBySlot[parent['slot-name']] = {};
            if (page_imageSection.section.section_content[this.language]) {
              BackgroundImageBySlot[parent['slot-name']].url =
                page_imageSection.section.section_content[this.language][
                  'image-url'
                ];
            } else {
              BackgroundImageBySlot[parent['slot-name']].url =
                page_imageSection.section.section_content.en['image-url'];
            }
            if (page_imageSection.section_display['is-overlay']) {
              BackgroundImageBySlot[parent['slot-name']]['data-color'] =
                page_imageSection.section_display['data-color'];
              BackgroundImageBySlot[parent['slot-name']]['data-color-opacity'] =
                page_imageSection.section_display['data-color-opacity'];
            }
          }
        });

      return BackgroundImageBySlot;
    },
    // PageSectionsBySlot() {
    //   if (this.language === null) {
    //     return {};
    //   }

    //   const res = {};

    //   this.page.page_type.page_type_content.structure.forEach((slot) => {
    //     res[slot['slot-name']] = [];

    //     res[slot['slot-name']] = this.pageSections.filter(
    //       page_section => page_section.section_display['slot-name'] === slot['slot-name'],
    //     );
    //   });
    //   return res;
    // },
    LevelTreeBySection() {
      const tree = {};
      let page_sections = [];
      this.page.page_content['slot-classes'].forEach((slot) => {
        if (slot.page_sections) {
          page_sections = page_sections.concat(slot.page_sections);
        }
      });
      let dashboardOnly = false;
      if (
        this.page &&
        this.page.page_type &&
        this.page.page_type.page_type_name === 'Dashboard Container'
      ) {
        dashboardOnly = true;
      }
      page_sections.forEach((page_section) => {
        if (
          page_section.section_display &&
          page_section.section_display.conditional_display
        ) {
          const { variable, value } =
            page_section.section_display.conditional_display;
          const urlValue = this.$cmsConsts.getValueFromPageLoaderVariables(
            this,
            variable
          );
          if (
            urlValue === false ||
            `${urlValue}`.toLowerCase() !== `${value}`.toLowerCase()
          ) {
            return;
          }
        }
        const leaf = {};
        tree[page_section.page_section_id] = leaf;
        leaf.data = page_section.section;
        leaf.sectionDisplay = page_section.section_display;
        leaf.section = page_section.section;
        leaf.component = `${page_section.section.section_type.section_type_name}Component`;
        leaf.language = this.language;
        leaf.entityId = this.entityId;
        leaf.dashboardOnly = dashboardOnly;
        const sectionContentKeys = Object.keys(
          page_section.section.section_content
        );
        if (
          sectionContentKeys.includes('en') &&
          !sectionContentKeys.includes(this.language)
        ) {
          leaf.language = 'en';
        }

        if (page_section.section_display['extra-levels']) {
          page_section.section_display['extra-levels'].sort((a, b) =>
            a.deep > b.deep ? 1 : -1
          );

          let levelBefore = {};
          let treeInitialized = false;

          page_section.section_display['extra-levels'].forEach((level) => {
            const nodeBuilder = {};
            if (!treeInitialized) {
              tree[page_section.page_section_id] = nodeBuilder;
              treeInitialized = true;
            } else {
              levelBefore.child = nodeBuilder;
            }
            nodeBuilder.child = leaf;

            nodeBuilder.class = level.class;
            nodeBuilder['html-tag'] = level['html-tag'];

            levelBefore = nodeBuilder;
          });
        }
      });
      return tree;
    },
    ExtraLevelTreeBySlot() {
      const tree = {};

      // eslint-disable-next-line
      // this.page.page_content['slot-classes'].find(elt => elt.templateId === this.page.page_type.page_type_id).slots.forEach((slot) => {
      this.page.page_content['slot-classes'].forEach((slot) => {
        tree[slot['slot-name']] = {};
        tree[slot['slot-name']].class = slot.class;
        tree[slot['slot-name']]['data-color'] = this.stylingBackgroundImage(
          slot['slot-name']
        )['data-color'];
        tree[slot['slot-name']]['data-color-opacity'] =
          this.stylingBackgroundImage(slot['slot-name'])['data-color-opacity'];
        tree[slot['slot-name']].style = this.stylingBackgroundImage(
          slot['slot-name']
        ).style;
        tree[slot['slot-name']]['html-tag'] = slot['html-tag'];
      });

      // const list_slots_page_content_with_extra_levels = this.page.page_content['slot-classes']
      //   .find(elt => elt.templateId === this.page.page_type.page_type_id).slots
      //   .filter(elt => elt['extra-levels']);

      const list_slots_page_content_with_extra_levels = this.page.page_content[
        'slot-classes'
      ].filter((elt) => elt['extra-levels']);

      list_slots_page_content_with_extra_levels.forEach((slot) => {
        slot['extra-levels'].sort((a, b) => (a.deep > b.deep ? 1 : -1));

        let levelBefore = null;
        let treeInitialized = false;

        slot['extra-levels'].forEach((level) => {
          const nodeBuilder = {};
          if (!treeInitialized) {
            tree[slot['slot-name']].child = nodeBuilder;
            treeInitialized = true;
          }
          nodeBuilder.class = level.class;
          nodeBuilder['html-tag'] = level['html-tag'];
          if (levelBefore) {
            levelBefore.child = nodeBuilder;
          }

          levelBefore = nodeBuilder;
        });
      });

      return tree;
    },
  },
  methods: {
    async initPage() {
      try {
        this.class_from_page = this.page.page_content['slot-classes'];
      } catch (e) {
        // console.log(e);
      }
      await new Promise((resolve) => setTimeout(resolve, 1000));
      this.initParallax();
      this.initNavBar();
    },
    stylingBackgroundImage(slotName) {
      if (!this.dataBackgroundImages[slotName]) {
        return '';
      }
      const styling = {};
      // eslint-disable-next-line
      styling.style = `background-image: url(${this.dataBackgroundImages[slotName].url}); background-repeat: no-repeat; background-size: cover; height:100%;`;
      styling['data-color'] = this.dataBackgroundImages[slotName]['data-color'];
      styling['data-color-opacity'] =
        this.dataBackgroundImages[slotName]['data-color-opacity'];
      return styling;
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find((key) => object[key] === value);
    },
    initNavBar() {
      // Init navbar
      // Navbar fade
      // console.log(document.querySelector('.navbar-wrapper.navbar-fade.navbar-light'));
      if (document.querySelector('.navbar-wrapper.navbar-fade.navbar-light')) {
        // document.querySelector('.navbar-placeholder').height(jQuery('.navbar-wrapper.navbar-fade').outerHeight());
        window.addEventListener('scroll', () => {
          const height = window.scrollY;
          if (height > 65) {
            const navbar = document.querySelector(
              '.navbar-wrapper.navbar-fade.is-transparent'
            );
            if (navbar) {
              navbar.classList.remove('is-transparent');
              navbar.classList.remove('navbar-light');
              navbar.classList.add('navbar-faded');
            }
          } else {
            const navbar = document.querySelector('.navbar-wrapper');
            if (navbar) {
              navbar.classList.remove('navbar-faded');
              navbar.classList.add('is-transparent');
              navbar.classList.add('navbar-light');
            }
          }
        });
      }

      // Navbar fade
      // if ($('.navbar-wrapper.navbar-fade.navbar-default').length) {
      //   $('.navbar-wrapper.navbar-fade').wrap(
      //     '<div class="navbar-placeholder"></div>'
      //   );
      //   $('.navbar-placeholder').height(
      //     jQuery('.navbar-wrapper.navbar-fade').outerHeight()
      //   );
      //   $(window).on('scroll', () => {
      //     const height = $(window).scrollTop();
      //     if (height > 65) {
      //       $('.navbar-wrapper.navbar-fade.is-transparent')
      //         .classList.remove('is-transparent')
      //         .classList.add('navbar-faded');
      //     } else {
      //       $('.navbar-wrapper')
      //         .classList.remove('navbar-faded')
      //         .classList.add('is-transparent');
      //     }
      //   });
      // }

      // Toggle the get started button color when solid navbar comes in
      // if (document.querySelector('.navbar-light')) {
      //   window.addEventListener('scroll', () => {
      //     const getStartedButton = document.querySelector('.button-getstarted');
      //     if (getStartedButton) {
      //       const height = window.scrollY;
      //       if (height > 80) {
      //         getStartedButton.classList.remove('light-btn');
      //         getStartedButton.classList.add('primary-btn');
      //       } else {
      //         getStartedButton.classList.remove('primary-btn');
      //         getStartedButton.classList.add('light-btn');
      //       }
      //     }
      //   });
      // }
    },
    async initParallax() {
      // eslint-disable-next-line no-unused-vars
      async function deleteAllExistingOverlays() {
        const allOverlays = document.getElementsByClassName('parallax-overlay');
        Object.keys(allOverlays).forEach(async (key) => {
          const overlayElt = allOverlays[key];
          if (overlayElt) {
            overlayElt.remove();
          } else {
            await new Promise((resolve) => setTimeout(resolve, 500));
            await deleteAllExistingOverlays();
          }
        });
      }
      function parallaxBG() {
        const allParallax = document.getElementsByClassName('parallax');
        if (!allParallax) {
          return;
        }
        Object.keys(allParallax).forEach((key) => {
          const parallaxElt = allParallax[key];
          // parallaxElt.style['background-attachment'] = 'fixed';

          const parrallax_overlay = document.createElement('div');
          parrallax_overlay.className = 'parallax-overlay';
          const arrayNodes = [...parallaxElt.childNodes];
          arrayNodes.forEach((node) => {
            if (node.classList) {
              node.classList.add('frontContent');
            } else {
              // eslint-disable-next-line no-param-reassign
              node.className = 'frontContent';
            }
          });
          parallaxElt.insertBefore(
            parrallax_overlay,
            parallaxElt.childNodes[0]
          );
          // const attrImage = parallax.getAttribute('data-background');
          const attrColor = parallaxElt.getAttribute('data-color');
          const attrOpacity = parallaxElt.getAttribute('data-color-opacity');
          // const attrPositionX = parallaxElt.getAttribute('data-position-x');
          // if (attrImage !== undefined) {
          //   parallax.style['background-image'] = `url(${attrImage})`;
          // }
          const overlay = parallaxElt.querySelector('.parallax-overlay');
          if (overlay) {
            if (attrColor !== undefined) {
              // eslint-disable-next-line no-param-reassign
              overlay.style['background-color'] = `${attrColor}`;
            }
            if (attrOpacity !== undefined) {
              // eslint-disable-next-line no-param-reassign
              overlay.style.opacity = `${attrOpacity}`;
            }
            // if (attrPositionX !== undefined) {
            //   // eslint-disable-next-line no-param-reassign
            //   parallaxElt.style['background-position-x'] = `${attrPositionX}`;
            // }
          }
        });
      }
      deleteAllExistingOverlays();
      parallaxBG();

      // if ('ontouchstart' in window) {
      //   document.documentElement.className = `${document.documentElement.className} touch`;
      // }
      // if (!$('html').hasClass('touch')) {
      //   $('.parallax').css('background-attachment', 'fixed');
      // }

      // function fullscreenFix() {
      //   const h = $('body').height();
      //   $('.content-b').each(function (i) {
      //     if ($(this).innerHeight() > h) {
      //       $(this).closest('.fullscreen').addClass('overflow');
      //     }
      //   });
      // }
      // $(window).resize(fullscreenFix);
      // fullscreenFix();

      // function backgroundResize() {
      //   const windowH = $(window).height();
      //   $('.parallax').each(function (i) {
      //     const path = $(this);
      //     const contW = path.width();
      //     const contH = path.height();
      //     let imgW = path.attr('data-img-width');
      //     let imgH = path.attr('data-img-height');
      //     const ratio = imgW / imgH;
      //     let diff = 0;
      //     diff = diff || 0;
      //     let remainingH = 0;
      //     if (path.hasClass('parallax') && !$('html').hasClass('touch')) {
      //       remainingH = windowH - contH;
      //     }
      //     imgH = contH + remainingH + diff;
      //     imgW = imgH * ratio;
      //     if (contW > imgW) {
      //       imgW = contW;
      //       imgH = imgW / ratio;
      //     }
      //     path.data('resized-imgW', imgW);
      //     path.data('resized-imgH', imgH);
      //     path.css('background-size', `${imgW}px ${imgH}px`);
      //   });
      // }
      // $(window).resize(backgroundResize);
      // $(window).focus(backgroundResize);
      // backgroundResize();

      // function parallaxPosition(e) {
      //   const heightWindow = $(window).height();
      //   const topWindow = $(window).scrollTop();
      //   const bottomWindow = topWindow + heightWindow;
      //   const currentWindow = (topWindow + bottomWindow) / 2;
      //   $('.parallax').each(function (i) {
      //     const path = $(this);
      //     const height = path.height();
      //     let { top } = path.offset();
      //     let bottom = top + height;
      //     if (bottomWindow > top && topWindow < bottom) {
      //       const imgH = path.data('resized-imgH');
      //       const min = 0;
      //       const max = -imgH + heightWindow;
      //       const overflowH = height < heightWindow ? imgH - height : imgH - heightWindow;
      //       top -= overflowH;
      //       bottom += overflowH;
      //       let value = 0;
      //       if ($('.parallax').is('.titlebar')) {
      //         value = min + (max - min) * (currentWindow - top) / (bottom - top) * 2;
      //       } else {
      //         value = min + (max - min) * (currentWindow - top) / (bottom - top);
      //       }
      //       let orizontalPosition = path.attr('data-oriz-pos');
      //       orizontalPosition = orizontalPosition || '50%';
      //       $(this).css('background-position', `${orizontalPosition} ${value}px`);
      //     }
      //   });
      // }
      // if (!$('html').hasClass('touch')) {
      //   $(window).resize(parallaxPosition);
      //   $(window).scroll(parallaxPosition);
      //   parallaxPosition();
      // }
      // if (navigator.userAgent.match(/Trident\/7\./)) {
      //   $('body').on('mousewheel', () => {
      //     event.preventDefault();
      //     const { wheelDelta } = event;
      //     const currentScrollPosition = window.pageYOffset;
      //     window.scrollTo(0, currentScrollPosition - wheelDelta);
      //   });
      // }
    },
  },
  watch: {
    // async pageSections() {
    //   if (this.pageSections.length > 0) {
    //     await new Promise(resolve => setTimeout(resolve, 1000));
    //     this.initParallax();
    //   }
    // },
  },
};
</script>
